/**
 * @file Album Upload action.
 */

import axios from 'axios';

import getLogger from '../util/logger';
import { photoUploadSuccess } from './photo-upload';

const log = getLogger('AlbumUploadAction');

export const ALBUM_UPLOAD_REQUEST = 'album/UPLOAD_REQUEST';
export const ALBUM_UPLOAD_SUCCESS = 'album/UPLOAD_SUCCESS';
export const ALBUM_UPLOAD_FAILURE = 'album/UPLOAD_FAILURE';
export const ALBUM_UPLOAD_PROGRESS = 'album/UPLOAD_PROGRESS';
export const ALBUM_UPLOAD_RESET = 'album/UPLOAD_RESET';

const albumUploadRequest = photos => {
  return { type: ALBUM_UPLOAD_REQUEST, photos };
};

const albumUploadSuccess = () => {
  return { type: ALBUM_UPLOAD_SUCCESS };
};

const albumUploadFailure = error => {
  return { type: ALBUM_UPLOAD_FAILURE, error };
};

const albumUploadProgress = photo => {
  return { type: ALBUM_UPLOAD_PROGRESS, photo };
};

export const albumUploadReset = () => {
  return { type: ALBUM_UPLOAD_RESET };
};

const photoUpload = async (
  accountId,
  albumId,
  photo,
  photosUploadMutation,
  albumAddPhotosMutation,
  albumPhotoGroupAddPhotosMutation,
  photoGroupId,
) => {
  const photoUploadsRes = accountId
    ? await photosUploadMutation(accountId, [
        { filename: photo.name, content_type: photo.type },
      ])
    : await photosUploadMutation(photo.name, photo.type);

  const photoUploadData = accountId
    ? photoUploadsRes.data.photosUpload.photo_uploads[0]
    : photoUploadsRes.data;

  await axios.put(photoUploadData.upload_url, photo, {
    headers: {
      'Content-Type': photo.type,
    },
  });

  await albumAddPhotosMutation(albumId, [photoUploadData.photo_id]);

  if (photoGroupId) {
    await albumPhotoGroupAddPhotosMutation(photoGroupId, [
      photoUploadData.photo_id,
    ]);
  }

  return photoUploadData;
};

export const albumUpload = async (
  accountId,
  albumId,
  photos,
  dispatch,
  photosUploadMutation,
  albumAddPhotosMutation,
  albumPhotoGroupAddPhotosMutation,
  photoGroupId,
) => {
  log.info('albumUpload() :: Uploading photos...', photos);

  dispatch(albumUploadRequest(photos));

  try {
    // eslint-disable-next-line no-restricted-syntax
    for (const photo of photos) {
      dispatch(albumUploadProgress(photo));

      // eslint-disable-next-line no-await-in-loop
      const res = await photoUpload(
        accountId,
        albumId,
        photo,
        photosUploadMutation,
        albumAddPhotosMutation,
        albumPhotoGroupAddPhotosMutation,
        photoGroupId,
      );

      dispatch(photoUploadSuccess({ id: res.photo_id, file: photo }, true));
    }

    dispatch(albumUploadSuccess());

    log.info('albumUpload() :: Upload finished');
  } catch (error) {
    log.error('albumUpload() :: Error:', error);

    dispatch(albumUploadFailure(error));
  }
};
